<template>
  <div class="entry-txt"
       v-html="infoTxt"/>
  <div class="join-stage-con mgt10">
    <div class="join-stage-input">
      <input type="text" placeholder="성명" title="성명"
             maxlength="50"
             v-model="mberNm"/>
    </div>
    <div class="join-stage-input">
      <div class="join-stage-box">
        <select v-model="mbpnTlno1">
          <option v-for="mbpn in $cmmn.txt.mbpns"
                  :key="mbpn"> {{ mbpn }}</option>
        </select>
        <number-ip style="width: 100px;"
                   :data="mbpnTlno2"
                   :maxlength="4"
                   @input="ipMbpnTlno2_input"/> -
        <number-ip style="width: 100px;"
                   :data="mbpnTlno3"
                   :maxlength="4"
                   @input="ipMbpnTlno3_input"/>
      </div>
    </div>
    <div class="join-stage-input">
      <input type="text" placeholder="아이디" title="아이디"
             ref="id" maxlength="20"
             v-model="mberId"/>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'취소'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'초대'"
         :color="'purple'"
          @click="btnNvtn_click"/>
  </div>
</template>

<script setup>
import {computed, defineProps, defineEmits, ref} from "vue"
import {getUtils, getStore} from "@/utils/import";
import NumberIp from "@/components/number-ip.vue";

const {$cmmn, $alert, $axios} = getUtils();
const {$mber, $loading} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  }
});

const infoTxt = ref('초대하실 회원의 <span class="pc01">성명, 휴대폰번호, 아이디</span>를 입력해주세요.');

const mberNm = ref('');
const mberId = ref('');
const mbpnTlno1 = ref('010');
const mbpnTlno2 = ref('');
const mbpnTlno3 = ref('');
const mbpnTlno = computed(() => mbpnTlno1.value + '-' + mbpnTlno2.value + '-' + mbpnTlno3.value);

const ipMbpnTlno2_input = (data) => {
  mbpnTlno2.value = data;
}

const ipMbpnTlno3_input = (data) => {
  mbpnTlno3.value = data;
}

const valid = () => {
  let isValid = true;
  let msg = '';

  return {isValid, msg};
}

const btnNvtn_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    const nvtnParams = {
      fcltySn: props.fcltySn,
      mberNm: mberNm.value,
      mberId: mberId.value,
      mbpnTlno: mbpnTlno.value
    };

    const tgtMberSn = await getIsFcltyMberNvtnPsbl(nvtnParams);
    if (!tgtMberSn) return false;

    await registerFcltyMberNvtn({fcltySn: nvtnParams.fcltySn, rqtMberSn: $mber.mberSn, tgtMberSn});
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const getIsFcltyMberNvtnPsbl = async (nvtnParams) => {
  const {data} = await $axios.get('/api/fclty/is-nvtn-psbl?' + $cmmn.txt.createQueryStr(nvtnParams));
  if (!data.isNvtnPsbl) {
    await $alert(data.msg);
    return false;
  }

  return data.mberSn;
}

const registerFcltyMberNvtn = async ({fcltySn, rqtMberSn, tgtMberSn}) => {
  const {data} = await $axios.post('/api/fclty/mber-nvtn', {fcltySn, rqtMberSn, tgtMberSn});

  if (data == 0) {
    await $alert('회원 초대 요청에 실패했습니다. 다시 시도해주세요.');
    return false;
  }

  await $alert('회원 초대 요청이 완료되었습니다.');
  close();
}

const emits = defineEmits(['close']);
const btnCancl_click = () => {
  close();
}

const close = () => {
  emits('close');
}
</script>

<style scoped>

</style>
